import React from "react";
import { Link } from "react-router-dom";
import CountdownTimer from "./CountdownTimer";
import {
  resetCode,
  runCode,
  semanticValidationException,
  executionStatus,
  executeCodeReset,
} from "../../features/competition/competitionSlice";
import { VscDebugRestartFrame } from "react-icons/vsc";
import { useSelector, useDispatch } from "react-redux";
import "./advent-footer.css";

function AdventFooter({ challenge }) {
  const { solution, executionStatus } = useSelector(
    (state) => state.competitions
  );
  const dispatch = useDispatch();

  const [thisChallenge] = challenge;
  const {
    previousChallengeSlug,
    nextChallengeSlug,
    contestTag,
    tag,
    type,
    enddate,
  } = thisChallenge || {};
  let moduleType = "Problem";

  const handleReset = () => {
    dispatch(executeCodeReset(thisChallenge._id));
    setTimeout(function () {
      window.location.reload();
    }, 600);
  };

  function basicSemanticValidation(apexBody) {
    apexBody = apexBody?.trim();
    if (!apexBody || !apexBody.includes(";")) {
      return "Unable to compile. You might be missing a semicolon";
    }
    return null;
  }

  function execute() {
    try {
      let validationError;
      if (!thisChallenge.editorlessChallenge && thisChallenge.type !== "SOQL") {
        validationError = basicSemanticValidation(solution);
      }
      if (!validationError) {
        const { timeZone } = Intl.DateTimeFormat().resolvedOptions();
        let body = {
          challengeId: thisChallenge._id,
          apexBody: solution != null ? solution.trim() : "",
          type: thisChallenge.type,
          timeZone,
        };
        dispatch(runCode(body));
      } else {
        dispatch(semanticValidationException(validationError));
      }
    } catch (e) {
      console.log(e);
    }
  }

  const renderLink = (to, text) => (
    <div className="col-span-1">
      <Link
        to={to}
        className="px-4 py-2 text-sm font-bold text-white bg-green-700 rounded-md hover:bg-green-800"
      >
        {text}
      </Link>
    </div>
  );

  const ResetButton = (
    <div className="tooltip pr-5" data-tip="Reset">
      <Link
        to=""
        onClick={handleReset}
        className="text-sm font-bold text-white"
      >
        <VscDebugRestartFrame className="text-2xl" />
      </Link>
    </div>
  );

  const CompetitionButton = (
    <div className="tooltip" data-tip="Head back to the main page">
      <Link
        to={
          contestTag == "apex-week-of-horror"
            ? "/advent/apex-week-of-horror"
            : "/advent/2025"
        }
        className="text-white hover:underline advent-sub"
      >
        {contestTag == "apex-week-of-horror"
          ? "Apex Week of Horror"
          : "Advent of Salesforce"}
      </Link>
    </div>
  );

  return (
    <div className="navbar advent-header">
      <div className="navbar-start">
        <div className="pr-2">
          {previousChallengeSlug && (
            <div>
              {renderLink(
                `/advent/${contestTag}/${previousChallengeSlug}`,
                `Last ${moduleType}`
              )}
            </div>
          )}
        </div>
        <div className="">
          {nextChallengeSlug && (
            <div>
              {renderLink(
                `/advent/${contestTag}/${nextChallengeSlug}`,
                `Next ${moduleType}`
              )}
            </div>
          )}
        </div>
      </div>

      <div className="navbar-center">{CompetitionButton}</div>

      <div className="navbar-end">
        <div className="flex items-center gap-4">
          <Link
            to=""
            onClick={execute}
            className="px-6 py-2 text-lg font-bold text-white bg-green-600 rounded-lg hover:bg-green-700"
          >
            Run Tests
          </Link>
          {thisChallenge.type !== "advent" && ResetButton}
        </div>
      </div>
    </div>
  );
}

export default AdventFooter;